module.exports = __webpack_public_path__ + "static/media/20.06.1e0f81ae.webp";